module.exports = __webpack_public_path__ + "img/win1.76d37631.png";